import { SectionBlock } from '../../_components/SectionBlock';
import styles from './DescriptionBlock.module.scss';

type Props = {
  description?: string;
};

export function DescriptionBlock( { description }: Props ) {
  const trimmed = description?.trim();

  return (
    <SectionBlock title="Description" data-testid="description-block">
      <p className={ trimmed ? styles.body : styles.empty }>
        { trimmed || 'No description provided' }
      </p>
    </SectionBlock>
  );
}
